import React, { useState } from 'react'
import CalendarIcon from '../../../Icon/CalenderIcon'
import CustomModal from '../../CustomModal';
import AppointmentSchedule from '../AppointmentSchedule';

function AppointmentSetup() {
  const [showEditAppointmentModal, setShowEditAppointmentModal] = useState(false);

  return (
    <div className="d-flex align-items-start" style={{ gap: '10px' }}>
        <CalendarIcon width={32} height={32} color="#121d55"/>
        <span className="text-dark">
            You have an <strong>Appointment Calendar</strong> defined
        </span>
        <button className="btn ms-3" style={{ background: '#121d55', color: 'white' }} onClick={() => setShowEditAppointmentModal(true)}>
            Edit
        </button>
        <CustomModal show={showEditAppointmentModal} setShow={setShowEditAppointmentModal} title={"Appointment Schedule"} extraClass={"appointment-modal-width"}>
            <AppointmentSchedule setShowEditAppointmentModal={setShowEditAppointmentModal}/>
        </CustomModal>
    </div>
  )
}

export default AppointmentSetup
